import { gql } from '@apollo/client';

export const getCurrencies = gql`
    query getCurrencies($requestedFrom: String, $currentPage: Int) {
      getCurrencies(requestedFrom: $requestedFrom, currentPage: $currentPage) {
        count
        results {
          id
          symbol
          isEnable
          isPayment
          isBaseCurrency
          status
        }
      }
    }
    `;

export const currency = gql`
  {
    Currency{
        base
        rates
    }
  }
`;

export const currencyManagement = gql`
    mutation currencyManagement ($id: Int, $isEnable: Boolean, $symbol: String){
        currencyManagement(id: $id, isEnable: $isEnable, symbol: $symbol){
            status
        }
    }
    `;

export const getBaseCurrency = gql`
    {
        getBaseCurrency{
          id
          symbol
        }
    }
    `;

export const setBaseCurrencyMutation = gql`
    mutation setBaseCurrency($id: Int){
        baseCurrency(id: $id){
            status
        }
    }
    `;

export const managePaymentCurrency = gql`
    mutation managePaymentCurrency(
      $currencyId: Int!, 
      $type: String!
    ){
        managePaymentCurrency(
          currencyId: $currencyId, 
          type: $type
        ) {
            status
        }
    }
    `;

export const updatePayoutCurrencyMutation = gql`mutation updatePayoutCurrency ($id: Int, $symbol: String , $isPayoutCurrency: Boolean){
          updatePayoutCurrency(id: $id, symbol: $symbol, isPayoutCurrency: $isPayoutCurrency){
                status
                errorMessage
            }
          }
`;